/* eslint-disable no-magic-numbers */

export enum RecordedInterviewSystemStatus {
  PASSED = 'PASSED',
  FAILED = 'FAILED',
  RESIT = 'RESIT',
  DELETED = 'DELETED',
  RECORDED = 'RECORDED',
  INVITED = 'INVITED',
  ATTEMPTED = 'ATTEMPTED',
  EXCEEDED = 'EXCEEDED',
  NONE = 'NONE'
}

export enum ThinkingTimeEnum {
  '15s' = 15,
  '30s' = 30,
  '45s' = 45,
  '1m' = 60,
  '1.5m' = 90,
  '2m' = 120,
  '3m' = 180,
  '4m' = 240,
  'Unlimited' = 0
}

export enum RecordingTimeEnum {
  '15s' = 15,
  '30s' = 30,
  '40s' = 40,
  '45s' = 45,
  '50s' = 50,
  '1m' = 60,
  '1.5m' = 90,
  '2m' = 120,
  '3m' = 180,
  '4m' = 240,
  '5m' = 300,
  '10m' = 600
}

export enum RetakesEnum {
  Zero = 0,
  One = 1,
  Two = 2,
  Three = 3,
  Four = 4,
  Five = 5
}

export enum QuestionTypeEnum {
  Standard = 'standard',
  Trap = 'trap'
}

export enum RecordedInterviewAssessmentDecision {
  None = 'None',
  Pass = 'Pass',
  Fail = 'Fail',
  Resit = 'Resit'
}
export enum ScoreTypeEnum {
  Score = 'Score',
  Audio = 'Audio',
  Language = 'Language'
}
